import React, {useState} from "react";

import {Button} from "primereact/button";
import {Message} from "primereact/message";

import {AppContext} from "../../HomePage";
import {CampaignContext} from "../../App";
import {ExportAsyncService} from "../../service/ExportAsyncService";

// The only report in the hub that is not scoped to the selected campaign: it
// is built from every campaign flagged as a base catalogue and matched
// against all the others. The base campaigns are listed on the screen so the
// difference from the campaign picker is visible rather than surprising.
const CategoryPriceComparison = () => {

    const {t, setError} = React.useContext(AppContext);
    const {campaigns, toggleDownloadReports} = React.useContext(CampaignContext);

    const [loading, setLoading] = useState(false);
    const [loadingWeekly, setLoadingWeekly] = useState(false);

    const exportAsyncService = new ExportAsyncService();

    const baseCampaigns = (campaigns || []).filter(
        campaign => campaign.settings && campaign.settings.category_price_comparison_base);

    // The tables that go out by mail: index, cheapest count and how far
    // above the market we sit, over the last week.
    const generateWeeklyReport = () => {
        setLoadingWeekly(true);
        exportAsyncService.exportCategoryPriceComparisonWeekly(7).then(() => {
            setLoadingWeekly(false);
            toggleDownloadReports(true);
        }).catch(error => {
            setError(error);
            setError(null);
            setLoadingWeekly(false);
        });
    };

    const generateReport = () => {
        setLoading(true);
        exportAsyncService.exportCategoryPriceComparison().then(() => {
            setLoading(false);
            toggleDownloadReports(true);
        }).catch(error => {
            setError(error);
            setError(null);
            setLoading(false);
        });
    };

    return <React.Fragment>
        <div className="p-grid card">
            <div className="p-col-12">
                <h3>{t('dashboard.category_price_comparison')}</h3>
                <hr/>
                <p>{t('dashboard.category_price_comparison_desc')}</p>
            </div>

            <div className="p-col-12">
                {baseCampaigns.length > 0 ?
                    <Message severity="info" style={{width: '100%', justifyContent: 'flex-start'}}
                             text={t('dashboard.category_price_comparison_base_campaigns') + ': '
                                 + baseCampaigns.map(campaign => campaign.name).join(', ')}/> :
                    <Message severity="warn" style={{width: '100%', justifyContent: 'flex-start'}}
                             text={t('dashboard.category_price_comparison_no_base_campaign')}/>}
            </div>

            <div className="p-col-12">
                <Button label={t('dashboard.category_price_comparison_generate')} icon="pi pi-file-excel"
                        className="p-button-raised p-button-success p-button-text"
                        disabled={baseCampaigns.length === 0}
                        onClick={generateReport} loading={loading}/>
                <Button label={t('dashboard.category_price_comparison_generate_weekly')} icon="pi pi-chart-bar"
                        className="p-button-raised p-button-success p-button-text p-ml-2"
                        disabled={baseCampaigns.length === 0}
                        onClick={generateWeeklyReport} loading={loadingWeekly}/>
            </div>
        </div>
    </React.Fragment>;
};

export default CategoryPriceComparison;
